const styles = ({ theme, width, height, menuHeight = null, menuWidth = 'clamp(220px, 100%, 480px)', keyField = 'id' }) => {
  return {
    option: (base, state) => {
      const values = state.getValue().map(value => value[keyField])
      const isSelected = state.data && values.includes(state.data[keyField])
      return {
        ...base,
        '&:active': {
          backgroundColor: theme.palette.grey[100],
        },
        '&:hover': {
          border: '1px solid #E5E7EB',
        },
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: 4,
        borderWidth: 1,
        cursor: 'pointer',
        borderStyle: 'solid',
        borderColor: isSelected
          ? theme.palette.grey[100]
          : theme.palette.common.white,
        padding: '2px 5px',
        marginBottom: 4,
        backgroundColor: isSelected
          ? theme.palette.grey[100]
          : theme.palette.common.white,
      }
    },
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu: (base) => ({
      ...base,
      width: menuWidth,
      zIndex: 9999,
      marginLeft: 1,
      cursor: 'pointer',
      overflow: 'hidden',
      margin: '8 0 0 0',
      borderRadius: 8,
      height: menuHeight
    }),
    menuList: (base) => ({
      ...base,
      margin: 8,
    }),
    noOptionsMessage: (base) => ({
      ...base,
      fontSize: 12,
    }),
    container: (base) => ({ 
      ...base, 
      display: 'flex',
      minWidth: 0,
      width: width || 'auto',
      height: height || 'auto',
    }),
    control: (base) => ({
      ...base,
      minHeight: height || 32,
      height: height || 32,
      width: width || '100%',
      minWidth: 0,
      border: '1px solid #EFEFEF',
      boxShadow: 'none',
      color: '#464646',
      fontSize: 12,
      fontWeight: 400,
      borderRadius: 8,
      '&:hover': {
        borderColor: '#EFEFEF',
      },
    }),
    indicatorsContainer: (base) => ({
      ...base,
      '&>div': { paddingTop: 0, paddingBottom: 0 },
    }),
    input: () => ({
      color: '#464646',
      fontSize: 12,
      fontWeight: 400,
      margin: 0,
      padding: 0,
      position: 'absolute',
      width: '100%',
      height: '100%',
    }),
    valueContainer: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
      width: '100%',
      height: '100%',
    }),
    placeholder: (base, { hasValue }) => ({
      fontWeight: 400,
      fontSize: 12,
      lineHeight: 2,
      color: '#464646',
      fontStyle: hasValue ? 'inherit' : 'italic',
      margin: 0,
    }),
    singleValue: (base) => ({
      ...base,
      color: '#464646',
      fontWeight: 400,
      fontSize: 12,
      lineHeight: 2,
    }),
  }
}

export default styles
